import Box from "@mui/material/Box";
import {useTheme} from "../../contexts/theme";
import Grid from "@mui/material/Grid";
import {Avatar, FormControl, Input, Typography} from "@mui/material";
import TransparentButton from "../CommonComponents/TransparentButton/TransparentButton";
import StyledInput from "../CommonComponents/StyledInput/StyledInput";
import {useAuth} from "../../contexts/auth";
import {useEffect, useState} from "react";
import {User, UserRole} from "../../types/users";
import StyledPopup from "../CommonComponents/StyledPopup/StyledPopup";


interface UserCardProps {
    changeUserInformation: (user: User, userId: string) => void;
    changePassword: (userId: string) => void;
}

const UserCard: React.FC<UserCardProps> = ({changeUserInformation, changePassword}: UserCardProps) => {

    const auth = useAuth();
    const theme = useTheme();

    const [disableInputText, setDisableInputText] = useState<boolean>(true)
    const [userInformation, setUserInformation] = useState<User>({
        email: "",
        id: "",
        name: "",
        roles: [],
        surname: "",
        username: "",
        organizations: []
    });



    const handleChangeInformation = (value: string, name: string) => {
        setUserInformation(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handelClickSaveInformation = () => {
        setDisableInputText(true);
        changeUserInformation(userInformation, userInformation.id);
    }



    useEffect(() => {
        if(auth.user) {
            setUserInformation({
                organizations: auth.user.organizations,
                name: auth.user.name,
                email: auth.user.email,
                surname: auth.user.surname,
                roles: auth.user.roles,
                id: auth.user.id,
                username: auth.user.username,
                password: auth.user.password
            })

        }
    },[])

    return (
        <Box sx={{
            width: "100%",
            boxShadow: 10,
            borderRadius: theme.spacing.md,
            paddingTop: theme.spacing.sm,
            marginBottom: theme.spacing.sm,
        }}>


        <Grid container direction="row" spacing={2} sx={{ height: "100%" }}>

            <Grid item xs={12} md={2} sx={{ height: "100%" }} justifyContent="center">
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",  // centra orizzontalmente
                    alignItems: "center",      // centra verticalmente
                    width: "100%",
                    height: "100%",
                }}>
                    <Avatar src="/broken-image.jpg" sx={{ width: 80, height: 80 }} />
                </Box>
            </Grid>

            <Grid item md={3} xs={12} sx={{ height: "100%" }}>
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",  // centra orizzontalmente
                    alignItems: "center",      // centra verticalmente
                    width: "100%",
                    height: "100%",
                }}>

                        <FormControl fullWidth={true}>
                        <StyledInput value={userInformation.name} color={theme.palette.white} disabled={disableInputText} onChange={(e) => handleChangeInformation(e.target.value, "name") }  />
                        </FormControl>

                </Box>
            </Grid>

                <Grid item md={3} xs={12} sx={{ height: "100%" }}>
                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",  // centra orizzontalmente
                        alignItems: "center",      // centra verticalmente
                        width: "100%",
                        height: "100%",
                    }}>

                        <FormControl fullWidth={true}>
                            <StyledInput value={userInformation.surname} color={theme.palette.white}  disabled={disableInputText} onChange={(e) => handleChangeInformation(e.target.value, "surname")} />
                        </FormControl>

                    </Box>
            </Grid>


            <Grid item md={2} xs={12} sx={{ height: "100%" }}>
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",  // centra orizzontalmente
                    alignItems: "center",      // centra verticalmente
                    width: "100%",
                    height: "100%",
                }}>
                               <TransparentButton  text={"Change Password"} onClick={()=>changePassword(userInformation.id)}/>
                </Box>
            </Grid>

                <Grid item md={2} xs={12} sx={{ height: "100%" }}>
                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",  // centra orizzontalmente
                        alignItems: "center",      // centra verticalmente
                        width: "100%",
                        height: "100%",
                    }}>


                                {disableInputText ?
                                    <TransparentButton  text={"Update"} onClick={()=>setDisableInputText(false)}/> :
                                    <TransparentButton  text={"Save"} onClick={()=>handelClickSaveInformation()}/>
                                }


                    </Box>
                </Grid>


        </Grid>

            <Grid container direction="row" spacing={2} height={'100%'} >

                <Grid item xs={12} md={2} sx={{ height: "100%" }} justifyContent="center">

                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",  // centra orizzontalmente
                        alignItems: "center",      // centra verticalmente
                        width: "100%",
                        height: "100%",
                    }}>

                    <FormControl fullWidth={true}>

                            <Typography variant="subtitle1" gutterBottom color = {theme.palette.white} textAlign={'center'} justifyContent={'center'} paddingTop={'16px'} marginBottom={0}>
                                {userInformation.organizations?.[0]?.name}
                            </Typography>



                        </FormControl>
                    </Box>
                </Grid>

                <Grid item md={3} xs={12} sx={{ height: "100%" }}>
                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",  // centra orizzontalmente
                        alignItems: "center",      // centra verticalmente
                        width: "100%",
                        height: "100%",
                    }}>


                                <FormControl fullWidth={true}>
                                    <StyledInput value={userInformation.email} color={theme.palette.white}  disabled={true} onChange={() => {}} />
                                </FormControl>
                    </Box>

                        </Grid>

                <Grid item md={3} xs={12} sx={{ height: "100%" }}>
                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",  // centra orizzontalmente
                        alignItems: "center",      // centra verticalmente
                        width: "100%",
                        height: "100%",
                    }}>


                        <FormControl fullWidth={true}>
                            <StyledInput value={userInformation.username} color={theme.palette.white} disabled={true} onChange={() => {}} />
                        </FormControl>
                    </Box>

                </Grid>

                </Grid>

        </Box>
    )
}

export default UserCard;